module.exports = __webpack_public_path__ + "static/media/your-loveprint-number.e2c375b2.svg";